import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

MetaHelmet.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonicalUrl: PropTypes.string,
};

export default function MetaHelmet({ title, description, keywords, canonicalUrl }) {
  const fullTitle = `${title} | خطوة المستثمر`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {/* {canonicalUrl && <link rel="canonical" href={canonicalUrl} />} */}
    </Helmet>
  );
}